// Значение, сокращённое многоточием, полностью видно в подсказке (SC-007). Подсказка и фокус
// с клавиатуры появляются, только когда текст действительно не помещается. Очень длинное
// значение подсказка показывает не дальше tipLines строк — целиком оно в карточке записи.
import { useLayoutEffect, useRef, useState } from 'react';
import type { CSSProperties } from 'react';
import { cx } from '../lib/cx.ts';
import { Tooltip } from './Tooltip.tsx';

export interface TruncateProps {
  text: string;
  /** Наибольшая ширина до многоточия. */
  maxWidth?: CSSProperties['maxWidth'];
  /** Строк в подсказке; по умолчанию — предел Tooltip. */
  tipLines?: number;
  className?: string;
}

export function Truncate({ text, maxWidth, tipLines, className }: TruncateProps) {
  const ref = useRef<HTMLSpanElement>(null);
  const [truncated, setTruncated] = useState(false);

  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return undefined;
    const measure = () => setTruncated(element.scrollWidth > element.clientWidth + 1);
    measure();
    if (typeof ResizeObserver === 'undefined') return undefined;
    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => observer.disconnect();
  }, [text]);

  return (
    <Tooltip content={text} disabled={!truncated} side="top" lines={tipLines}>
      <span
        ref={ref}
        className={cx('kp-trunc', className)}
        style={maxWidth !== undefined ? { maxWidth } : undefined}
        tabIndex={truncated ? 0 : undefined}
      >
        {text}
      </span>
    </Tooltip>
  );
}
